/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FilterDesc/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FilterDesc({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2FilterDesc",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2FilterDesc.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-Y8GpU': alignSelf,'--mt-2-Y8GpU': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Y8GpU': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Y8GpU': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Y8GpU': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Y8GpU': opacity,'--w-10-Y8GpU': typeof width === 'number' ? `${width}px` : width,'--h-11-Y8GpU': typeof height === 'number' ? `${height}px` : height,'--f-12-Y8GpU': fill,'--a-7-Y8GpU': isAnimated ? animation : "none",'--sd-8-Y8GpU': isAnimated ? strokeDashoffset : 0,'--sd-9-Y8GpU': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2FilterDesc.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.25 0a.75.75 0 000 1.5h2a.75.75 0 000-1.5h-2zm-2 3a.75.75 0 000 1.5h4a.75.75 0 000-1.5h-4zM0 6.75A.75.75 0 01.75 6h6.5a.75.75 0 010 1.5H.75A.75.75 0 010 6.75zM10.75 0a1 1 0 011 1v9h1.5a.75.75 0 01.53 1.28l-2.5 2.5a.75.75 0 01-1.06 0l-2.5-2.5A.75.75 0 018.25 10h1.5V1a1 1 0 011-1z"
 style={{'--f-12-Y8GpU': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}